import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fnsr-imprint',
  templateUrl: './imprint.component.html'
})
export class ImprintComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
